import { useMediaQuery } from '@mui/material';

export const useMobile = () => useMediaQuery('(max-width: 660px)');
